import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Link from 'next/link'

import Typography from '../../typography'
import { useBreakpoint } from '../../../../hooks/breakpoint'
import Share from '../../share/simple'
import { getNews } from '../../../../api/bantrab'
import { NEWS_LIST_QUERY as ITEMS_LIST_QUERY } from '../../../../api/bantrab/queries'

import Body from '../../legal/detail/body'

import styles from '../../../../styles/bantrab/components/blog.module.scss'

const Details = ({ article, ...attrs }) => {
  const breakpoint = useBreakpoint()
  const [recentEntries, setRecentEntries] = useState([])

  const { className } = attrs
  attrs.className = classNames(className, {
    [styles.details]: true
  })

  const fetchRecentEntries = async () => {
    let fetchedEntries = await getNews({
      ...ITEMS_LIST_QUERY,
      limit: 5
    })
    fetchedEntries = await fetchedEntries.json()
    setRecentEntries([...fetchedEntries.items])
  }

  useEffect(
    async () => {
      await fetchRecentEntries()
    },
    []
  )

  return <section
    className={
      classNames(
        [
          'relative',
          'pt-8',
          'pb-10',
          'md:pt-12',
          'md:pb-16',
          'md:bg-white'
        ]
      )
    }>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames(
            [
              'flex',
              'flex-row',
              'flex-wrap',
              'items-start',
              '-mx-4'
            ]
          )
        }>
        <div
          className={
            classNames([
              'relative',
              'px-4'
            ])
          }
          style={{
            width: breakpoint.lgAndUp ? '30%' : (breakpoint.mdAndUp ? '30%' : '100%'),
            flexBasis: breakpoint.lgAndUp ? '30%' : (breakpoint.mdAndUp ? '30%' : '100%')
          }}>
          {
            recentEntries.length > 0
              ? recentEntries.map(
                entry => {
                  return (
                    <Typography
                      key={entry.id}
                      size={'one'}
                      weight={'medium'}
                      className={'mb-4 w-full md:w-3/4 curso-pointer'}>
                      <Link
                        href={`/blog/${entry.id}/${entry.meta.slug}`}>
                        {entry.title}
                      </Link>
                    </Typography>
                  )
                }
              )
              : null
          }
          <Share
            url={`/blog/${article.id}/${article.meta.slug}`} />
        </div>
        <div
          className={
            classNames(
              [
                'relative',
                'px-4'
              ]
            )
          }
          style={{
            width: breakpoint.lgAndUp ? '70%' : (breakpoint.mdAndUp ? '70%' : '100%'),
            flexBasis: breakpoint.lgAndUp ? '70%' : (breakpoint.mdAndUp ? '70%' : '100%')
          }}>
          <Body content={article.body} />
        </div>
      </div>
    </div>
  </section>
}

Details.propTypes = {
  article: PropTypes.object
}

export default Details
